import React from "react";
import { Routes, Route } from "react-router-dom";
import SignInPage from "./pages/SignInPage.jsx"; 
import SignUpPage from "./pages/SignUpPage.jsx";
import UserDashboard from "./pages/UserDashboard.jsx";
import QuizPage from "./pages/QuizPage.jsx";
import ProfilePage from "./pages/ProfilePage.jsx";
import UserProfile from './pages/UserProfile';
import Notification from "./pages/Notification.jsx"; 
import Legal from "./pages/Legal.jsx"; 
import SubscriptionPage from "./pages/SubscriptionPage.jsx"; // Changed: capital S and renamed to SubscriptionPage

const App = () => {
    return (
        <div style={styles.root}>
            <Routes>
                {/* The root path / remains the main entry point */}
                <Route path="/" element={<SignInPage />} /> 
                <Route path="/signin" element={<SignInPage />} /> 
                
                {/* Routes */}
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/userDashboard" element={<UserDashboard />} />
                <Route path="/quizPage" element={<QuizPage />} />
                
                {/* Profile Pages */}
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/profile/:userId" element={<UserProfile />} />

                {/* Add the Route for Notifications */}
                <Route path="/notifications" element={<Notification />} />

                {/* Add the Route for Legal and Support */}
                <Route path="/legal" element={<Legal />} />

                {/* Fixed: Using SubscriptionPage component with capital S */}
                <Route path="/subscription" element={<SubscriptionPage />} />
            </Routes>
        </div>
    );
};

const styles = {
    root: {
        fontFamily: "'Inter', sans-serif",
    },
};

export default App;